import { GetStaticProps } from "next";
import { Main } from "@/components";
import { WordPressTemplateProps } from "@/types";
import { getWordPressProps, WordPressTemplate } from "@faustwp/core";
import { REVALIDATE_TIME } from "@/core/constants";
import { getPageWrapperData } from "@/core/pageWrapperCache";

export default function Page(props: WordPressTemplateProps) {
  const { __SEED_NODE__: { isFrontPage, } } = props;
  const style = isFrontPage ? { '--highlight-color': "var(--green)" } : {};
  return (
    <Main style={style}>
      <WordPressTemplate {...props} />
    </Main>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const pageWrapperData = await getPageWrapperData();
  return getWordPressProps({
    ctx,
    revalidate: REVALIDATE_TIME,
    props: { pageWrapperData }
  });
};